// extracted by mini-css-extract-plugin
export default {"innerWrapper":"qv-z","tooltipWrapper":"rv-z","icon":"sv-z","tooltip":"tv-z","content":"uv-z"};